import { render } from "./AddTodo.vue?vue&type=template&id=12c6e170&scoped=true"
import script from "./AddTodo.vue?vue&type=script&lang=js"
export * from "./AddTodo.vue?vue&type=script&lang=js"

import "./AddTodo.vue?vue&type=style&index=0&id=12c6e170&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c6e170"]])

export default __exports__